import DatetimeMixin from '@/mixins/datetime-mixin';
import HistoryHelpers from '@/mixins/history-helpers';
import { mapGetters } from 'vuex';

import {
	MODULE_NAME as OPTION_MODULE_NAME,
	LOGS
} from '@/sections/logs/logs-mutation-type';

import _ from 'lodash';

export default {
	mixins: [DatetimeMixin, HistoryHelpers],
	updated() {
		this.$nextTick(() => {
			if (this.$refs.actionWidthRef) {
				const newWidth = this.$refs.actionWidthRef.clientWidth;

				if (
					!this.actionClientWidth &&
					newWidth !== this.actionClientWidth
				) {
					this.refreshSource(newWidth);
				}
			}
		});
	},
	mounted() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowSizeChange);
	},
	computed: {
		...mapGetters(OPTION_MODULE_NAME, [LOGS])
	},
	methods: {
		async renderLogs() {
			let results = _.cloneDeep(this[LOGS]);

			if (results.items?.length > 0) {
				results.items.forEach(item => {
					item.description = item.entityDescription;

					if (item?.fieldChanges?.items?.length > 0) {
						if (
							item.fieldChanges.items[0]?.ChangedPropertyName ===
							'Released'
						) {
							item.goLive = true;
							item.actionDescription= '<strong>Beta Feature Go Live</strong> ';
						} else {
							const addedItems = this.getActionItems(
								item.fieldChanges.items,
								'Add',
								item.data
							);
							const removedItems = this.getActionItems(
								item.fieldChanges.items,
								'Delete',
								item.data
							);
							let actionValues = [];
							if (addedItems.length > 0) {
								actionValues.push(
									`<strong>Added</strong> ${addedItems.join(
										', '
									)}`
								);
							}
							if (removedItems.length > 0) {
								actionValues.push(
									`<strong>Removed</strong> ${removedItems.join(
										', '
									)}`
								);
							}
							item.actionDescription = actionValues.join(', ');
							item.goLive = false;
						}
					}
				});
			}
			this.tableSource.source = { ...results };
		},
		async refreshSource(newWidth) {
			this.actionClientWidth = newWidth;
			let featureHistoryLogs = _.cloneDeep(this[LOGS]);

			if (!_.isEmpty(featureHistoryLogs)) {
				await this.renderLogs();
			}
		}
	},
	watch: {
		windowWidth: {
			deep: true,
			handler() {
				if (this.$refs.actionWidthRef) {
					const newWidth = this.$refs.actionWidthRef.clientWidth;
					if (newWidth != this.actionClientWidth) {
						this.refreshSource(newWidth);
					}
				}
			}
		}
	}
};
